import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbPersonalInfoInterface } from '../interfaces/eb-common-form.interface'

export const CUSTOMER_INFO_NORMALIZER = new InjectionToken<Converter<any, EbPersonalInfoInterface>>(
  'CustomerInfoNormalizer'
)
